module.exports = __webpack_public_path__ + "static/objective-aac3f576a94de612ff7055cd4d158c80.jpg";